import React from 'react';
import PropTypes from 'prop-types';
import APCheckbox from '../../common/APCheckbox';
import APButton from '../../common/APButton';
import classnames from 'classnames';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './CreateApiKeyComponent.css';
var baseClasses = getBEMClasses('create-api-key');
var CreateApiKeyComponent = function CreateApiKeyComponent(props, context) {
  var error = props.error,
    pristine = props.pristine;
  return React.createElement('form', {
    onSubmit: props.handleSubmit,
    className: classnames('form-inline', baseClasses('slide-pane-body'))
  }, React.createElement('div', {
    className: baseClasses('header')
  }, context.t('Create New API Key')), React.createElement('div', {
    className: baseClasses('form-body')
  }, React.createElement('div', {
    className: baseClasses('frame')
  }, React.createElement('div', {
    className: baseClasses('title')
  }, context.t('Choose the following activities to allow the API Key to access:')), React.createElement('div', {
    className: baseClasses('input-wrapper')
  }, React.createElement(APCheckbox, {
    name: 'trading',
    label: context.t('Trading'),
    id: 'trading',
    customClass: baseClasses()
  })), React.createElement('div', {
    className: baseClasses('input-wrapper')
  }, React.createElement(APCheckbox, {
    name: 'deposit',
    label: context.t('Deposits'),
    id: 'deposit',
    customClass: baseClasses()
  })), React.createElement('div', {
    className: baseClasses('input-wrapper')
  }, React.createElement(APCheckbox, {
    name: 'withdraw',
    label: context.t('Withdrawals'),
    id: 'withdraw',
    customClass: baseClasses()
  })), React.createElement('div', {
    className: baseClasses('input-wrapper')
  }, React.createElement(APCheckbox, {
    name: 'accountReadOnly',
    label: context.t('Read Only'),
    id: 'viewonly',
    customClass: baseClasses()
  })), error && pristine ? React.createElement('div', {
    className: baseClasses('error')
  }, error) : null), React.createElement('div', {
    className: baseClasses('footer')
  }, React.createElement(APButton, {
    type: 'submit',
    customClass: baseClasses(),
    disabled: props.submitting,
    styleName: 'additive'
  }, props.submitting ? context.t('Processing...') : context.t('Create')))));
};
CreateApiKeyComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
CreateApiKeyComponent.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
};
export default CreateApiKeyComponent;